import React, { useEffect, useState, useRef } from "react";
import product from "@/assets/dashboard/product.png";
function ProductInfomations() {
  return (
    <div style={{ width: "100%" }}>
      <img
        src={product}
        alt="product"
        style={{
          width: "100%",
          height: "2000px",
        }}
      />
    </div>
  );
}

export default ProductInfomations;
